<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="100" inline>
        <FormItem label="工作量统计" >
        </FormItem>
        <FormItem label="选择医院">
          <Select @on-change="keshi_list" :placeholder="table.search.ExamOrganCode" v-model="table.search.ExamOrganCode" class="w-250" clearable> 
            <Option
              v-for="(item, index) in DicSelect"
              :value="JSON.stringify(item)"
              :key="index"
              >{{ item.organName }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="选择科室">
          <Select @on-change="keshi_change" :placeholder="table.search.RequestDepartment" v-model="table.search.RequestDepartment" class="w-250" clearable> 
            <Option
              v-for="(item, index) in DicSelect_KESHI"
              :value="item.departmentName"
              :key="index"
              >{{ item.departmentName }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="本院在职医生:">
          <label>{{hos_docnum}}</label>
        </FormItem>
        <FormItem label="工作量总计:">
          <label>{{work_total}}</label>
        </FormItem>
      </Form>
      <div>
          <Button class="mr-3" type="success" @click="search">查询</Button>
          <!-- <Button class="mr-3" type="primary" @click="exportExcel">导出</Button> -->
      </div>
    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      @sum41="sum41"
      :width="500"
    ></DataTable>
    <!-- 弹框 -->
    <!-- <Modal
        v-model="modal1"
        title="提示"
        @on-ok="ok"
        >
        <Icon type="information-circled"></Icon>
        您要选择医院和科室才可查询数据
    </Modal> -->
  </div>
</template>
<script>
import DataTable from "@/components/NoPageDataTable.vue";

export default {
  components: { DataTable },
  data: function () {
    return {
      // 新增
       DicSelect: [],
       ExamOrganCode:'null',  //医院编号
       RequestDepartment:null,  //科室名称
       his_organID:null,  //医院  医生请求参数
       hos_docnum:null,
       work_total:0,
       DicSelect_KESHI:[],
      //  ExamTypeSelect:['测试CT','测试MG','测试DX'],
       ExamTypeSelect:[],
        modal1: false,
         
          loading: false,
          
      EmailSendFlagSelect: [],
      currentData: {},
      detailModal: false,
      table: {
        columns: [
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          // { title: "检查医院", key: "examDepartment" },
          // { title: "申请科室", key: "examOrganCode" },
          { title: "检查类型", key: "examTypeName" },
          { title: "工作量", key: "orderIDcount" },
        ],
        apiUrl: "client/Cstatistics",
        search: {
          // begintime: "",
          // endtime: "",
          ExamOrganCode: "",  //选择医院
          RequestDepartment:''  //科室
        },
      },
    };
  },

  activated: function () {
    // this.modal1 = true

    this.clientLogTypeSelect = this.$common.getJsonData("clientLogType");
    let organCode = localStorage.getItem("organCode");
    let userType = localStorage.getItem("userType");
      console.log('organCode',organCode);
    if (!userType.indexOf("管理员")) {
      this.table.search.ExamOrganCode = organCode;
    }
    

    //获取检查类型数据 
    //  var _this = this;
    this.$common.getDictionaryByCode("JCLX").then((data) => {
      // console.log('data数据',data);
      this.ExamTypeSelect = data;
    });
    this.hispatil_list()
    // this.hispatil_docnum()
    this.$refs.dataTable.initload22();
  },

  methods: {
    // 新增
     ok () {
        // this.$Message.info('点击了确定');
    },
    cancel () {
        // this.$Message.info('点击了取消');
    },
    sum41(sum41){
      // console.log('父',sum41);
      this.work_total = sum41
    },
    clean_list(){
       this.DicSelect= []
       this.DicSelect_KESHI= []
    },
    // 医院下拉框列表
    hispatil_list(){
      this.$api.get(`client/organinfo`).then((rsp) => {
        if (rsp != false) {
          this.DicSelect= rsp.data;
          console.log('医院类型数据',this.DicSelect);
          // this.loading = false;
          this.table.search.ExamOrganCode = rsp.data[0].organCode

          this.keshi_list(JSON.stringify(rsp.data[0]))
          console.log('医院类型数据', this.table.search.ExamOrganCode);
        }
      });
    },
    // 点击医院下拉 请求框科室下拉框数据
     keshi_list(organ){
        
       organ = JSON.parse(organ)
       console.log(organ)
      //  console.log('科室数据',organ,);
       this.ExamOrganCode = organ.organCode  //医院编号
       this.his_organID = organ.organID  //医院员工总数 请求参数
       this.$nextTick(()=>{
         this.hispatil_docnum()
       })
      this.$api.get(`client/departmentinfo?OrganID=${organ.organID}`).then((rsp) => {
        if (rsp != false) {
          this.DicSelect_KESHI= rsp.data;
          // console.log('科室数据',rsp);
          // this.loading = false;
        }
      });

      // 点击另一个医院时清空科室数据
       this.table.search.RequestDepartment = ''
       this.hos_docnum = 0
       this.work_total = 0
    },
    keshi_change(organ){
      // console.log('选中科室数据',organ);
        this.RequestDepartment = organ //科室编号
    },
    // 当前医院员工总数
    hispatil_docnum(){
      this.$api.get(`client/usercounta?OrganID=${this.his_organID}`).then((rsp) => {
        if (rsp != false) {
          this.hos_docnum= rsp.data[0].usercount;
          // console.log('员工总数',rsp.data[0].usercount);
          // this.loading = false;
        }
      })
    },
    search: function () {
      this.$refs.dataTable.initload22(1);
      this.hispatil_docnum()
      // console.log('时间',this.table.search);
    },
    // 导出Excel
    exportExcel: function () {
      var urls ="/"+ this.table.apiUrl + "exportExcel?";
      let baseUrl = localStorage.getItem("baseURL");
      const Qs = require("qs");
      let params = Qs.stringify(this.table.search);
      let url = baseUrl + urls + params;
      console.log(url);
      window.open(url);
    },
    toDetail: function (data) {
      this.detailModal = true;
      this.currentData = data;
    },
  },
};
</script>
<style scoped>
</style>